import Link from 'gatsby-link';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Image, Menu, Responsive } from 'semantic-ui-react';
export default class Topbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuOpen: false
        }
    }

    handleItemClick = (e, { name }) => this.setState({ activeItem: name })

    handleMenuOpen = () => {
        let state = !this.state.menuOpen
        this.setState({ menuOpen:  state})
        this.props.menuOpen(state)
    }

    render() {
        const { activeItem, menuOpen } = this.state
        return (
            <div>
                <Responsive minWidth={Responsive.onlyTablet.minWidth}>
                    <Menu secondary className="mpost-topbar">
                        <Menu.Item
                            as={Link}
                            to="/"
                            className="mpost-brand--menu"
                        >
                            <Image src={require('../assets/img/logo-brand.svg')} size="small" />
                        </Menu.Item>

                        <Menu.Menu position="right">
                            <Menu.Item
                                name='works'
                                className="mpost-topbar-item"
                                as={Link}
                                active={activeItem === 'works'}
                                onClick={this.handleItemClick}
                                to="/work/"
                            >
                                WORKS
                    </Menu.Item>
                            <Menu.Item
                                name='services'
                                className="mpost-topbar-item"
                                as={Link}
                                active={activeItem === 'services'}
                                onClick={this.handleItemClick}
                                to="/services/"
                            >
                                SERVICES
                    </Menu.Item>
                            <Menu.Item
                                name='contact'
                                className="mpost-topbar-item"
                                as={Link}
                                active={activeItem === 'contact'}
                                onClick={this.handleItemClick}
                                to="/contact/"
                            >
                                CONTACT
                    </Menu.Item>
                        </Menu.Menu>
                    </Menu>
                </Responsive>
                <Responsive {...Responsive.onlyMobile}>
                
                    <Menu secondary className="mpost-topbar mobile">
                        <Menu.Item
                            as={Link}
                            to="/"
                            className="mpost-brand--menu"
                        >
                            <Image src={require('../assets/img/logo-brand.svg')} size="tiny" />
                        </Menu.Item>
                        <Menu.Menu position="right">
                            <Button onClick={this.handleMenuOpen} icon="sidebar" basic className="mpost-sidebar--button" />
                        </Menu.Menu>
                    </Menu>
                    
                </Responsive>
            </div>
        )
    }
}

Topbar.propTypes = {
    menuOpen: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/Topbar.js